import * as i1 from '@acorex/components/common';
import { AXEvent, MXBaseComponent, AXValuableComponent } from '@acorex/components/common';
import { AXLabelComponent } from '@acorex/components/label';
import { AXSelectBoxComponent } from '@acorex/components/select-box';
import { AXUnsubscriber } from '@acorex/core/utils';
import * as i0 from '@angular/core';
import { input, EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, Output, Input, signal, inject, ViewContainerRef, afterNextRender, effect, ContentChild, HostBinding, InjectionToken, Directive, Optional, Inject, NgModule } from '@angular/core';
import * as i3 from '@acorex/components/alert';
import { AXAlertModule } from '@acorex/components/alert';
import * as i4 from '@acorex/components/button';
import { AXButtonModule } from '@acorex/components/button';
import * as i2 from '@acorex/components/decorators';
import { AXDecoratorModule } from '@acorex/components/decorators';
import * as i6 from '@acorex/core/translation';
import { translateSync, AXTranslationModule } from '@acorex/core/translation';
import { AXValidationModule } from '@acorex/core/validation';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@acorex/components/toast';

/**
 *  Contains native event
 * @category Events
 */
class AXFormValidationEvent extends AXEvent {
}
/**
 * The AXForm is a component which detects user interaction and triggers a corresponding event
 *
 * @category Components
 */
class AXFormComponent extends MXBaseComponent {
    get updateOn() {
        return this._updateOn;
    }
    set updateOn(v) {
        this.setOption({
            name: 'updateOn',
            value: v,
            afterCallback: () => {
                //this._bindEvents();
            },
        });
    }
    async _handleSubmit(e) {
        e.preventDefault();
        await this.validate();
    }
    _handleReset() {
        this.reset();
    }
    constructor() {
        super();
        this.labelMode = input('static');
        this.messageStyle = input('bottom');
        this.onValidate = new EventEmitter();
        this.updateOnChange = new EventEmitter();
        this._updateOn = 'blur';
        this._subs = [];
    }
    //TODO: check update on
    // ngAfterViewInit(): void {
    //   //this._bindEvents();
    // }
    // private _bindEvents() {
    //   this._clearSubs();
    //   const widgets = this._getComponenets();
    //   //
    //   widgets.forEach((w) => {
    //     if (this.updateOn == 'change') {
    //       this._subs.push(
    //         w.onValueChanged?.subscribe((v: AXValueChangedEvent) => {
    //           if (v.isUserInteraction) w.validate();
    //         }),
    //       );
    //     } else if (this.updateOn == 'blur') {
    //       this._subs.push(
    //         w.onBlur?.subscribe((v) => {
    //           w.validate();
    //         }),
    //       );
    //     }
    //   });
    // }
    _clearSubs() {
        this._subs.forEach((c) => c?.unsubscribe());
        this._subs = [];
    }
    get fields() {
        return Array.from(this.getHostElement().querySelectorAll('[ax-form-item="true"]'))
            .map((c) => c.__axContext__)
            .filter((c) => c != null);
    }
    async validate(...names) {
        const results = await Promise.all(this.fields.filter((c) => names == null || names.length == 0 || names.includes(c.name)).map((field) => field.validate()));
        // Merge all validation summaries into one
        const mergedSummary = {
            result: results.every((res) => res.result),
            rules: results.flatMap((res) => res.rules),
        };
        this._emitOnValidateEvent(mergedSummary);
        return mergedSummary;
    }
    _emitOnValidateEvent(e) {
        this.onValidate.emit({
            component: this,
            result: e,
            htmlElement: this.getHostElement(),
        });
    }
    reset() {
        this.fields.forEach((c) => c.reset(false));
    }
    resetErrors() {
        this.fields.forEach((c) => c.resetErrors());
    }
    ngOnDestroy() {
        this._clearSubs();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.0.2", type: AXFormComponent, selector: "ax-form", inputs: { labelMode: { classPropertyName: "labelMode", publicName: "labelMode", isSignal: true, isRequired: false, transformFunction: null }, messageStyle: { classPropertyName: "messageStyle", publicName: "messageStyle", isSignal: true, isRequired: false, transformFunction: null }, updateOn: { classPropertyName: "updateOn", publicName: "updateOn", isSignal: false, isRequired: false, transformFunction: null } }, outputs: { onValidate: "onValidate", updateOnChange: "updateOnChange" }, usesInheritance: true, ngImport: i0, template: `<form (submit)="_handleSubmit($event)" (reset)="_handleReset()" class="ax-{{ messageStyle() }}-error">
    <ng-content></ng-content>
  </form>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ax-form',
                    template: `<form (submit)="_handleSubmit($event)" (reset)="_handleReset()" class="ax-{{ messageStyle() }}-error">
    <ng-content></ng-content>
  </form>`,
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [], propDecorators: { onValidate: [{
                type: Output
            }], updateOnChange: [{
                type: Output
            }], updateOn: [{
                type: Input
            }] } });

class AXFormFieldComponent extends MXBaseComponent {
    constructor() {
        super();
        this.labelMode = input('static');
        this._labelMode = signal(this.labelMode());
        this.unsubscriber = inject(AXUnsubscriber);
        this.form = inject(AXFormComponent, { optional: true });
        this.host = inject(ViewContainerRef);
        afterNextRender(() => {
            this.calcIndentSize();
            this.setRequired();
            this.setLabelMode();
            this.listeningEvent();
        });
        effect(() => {
            this.setLabelMode();
        }, { allowSignalWrites: true });
    }
    calcIndentSize() {
        const prefix = this.input?.getHostElement()?.querySelector('ax-prefix');
        if (prefix) {
            this.label.getHostElement().style.insetInlineStart = prefix?.clientWidth + 'px';
        }
    }
    setRequired() {
        this.autoSetRequired();
        this.input?.validationRulesChange.pipe(this.unsubscriber.takeUntilDestroy).subscribe(() => {
            this.autoSetRequired();
        });
    }
    setLabelMode() {
        this._labelMode.set(this.form?.labelMode());
    }
    listeningEvent() {
        const focusEvent = this.input?.['onFocus'];
        focusEvent?.subscribe((e) => {
            // this.handleFloating('focus');
            this.host.element.nativeElement.classList.add('ax-state-focused');
        });
        //
        const blurEvent = this.input?.['onBlur'];
        blurEvent?.subscribe((e) => {
            // this.handleFloating('blur');
            this.host.element.nativeElement.classList.remove('ax-state-focused');
        });
    }
    // protected handleFloating(mode: 'focus' | 'blur') {
    //   const _host = this.host.element.nativeElement as HTMLElement;
    //   const placeholder = this.input;
    //   switch (mode) {
    //     case 'focus':
    //       _host.classList.add('ax-state-floating');
    //       this.label.getHostElement().style.insetInlineStart = 'inherit';
    //       break;
    //     case 'blur':
    //       _host.classList.remove('ax-state-floating');
    //       break;
    //   }
    // }
    autoSetRequired() {
        if (this.label && this.input) {
            if (this.label.required == null || this.label['autoSetRequired']) {
                this.label.required = this.input.isRequired;
                this.label['autoSetRequired'] = true;
            }
        }
    }
    get __hostClass() {
        let hasValue;
        if (this.input) {
            if (this.input instanceof AXSelectBoxComponent) {
                hasValue = this.input.value?.length;
            }
            else {
                hasValue = this.input.value;
            }
        }
        return [`ax-state-${this._labelMode()}-label`, `${hasValue ? 'ax-state-has-value' : ''}`];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "18.0.2", type: AXFormFieldComponent, selector: "ax-form-field", inputs: { labelMode: { classPropertyName: "labelMode", publicName: "labelMode", isSignal: true, isRequired: false, transformFunction: null } }, host: { properties: { "class": "this.__hostClass" } }, providers: [AXUnsubscriber], queries: [{ propertyName: "input", first: true, predicate: AXValuableComponent, descendants: true }, { propertyName: "label", first: true, predicate: AXLabelComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, styles: [".ax-dark ax-form.ax-form-normal .ax-error-message{border-color:rgba(var(--ax-color-danger-500));background-color:rgba(var(--ax-color-danger-200));color:rgba(var(--ax-color-danger-fore-tint))}.ax-dark ax-form.ax-form-normal .ax-error-message:before,.ax-dark ax-form.ax-form-normal .ax-error-message:after{border-bottom-color:rgba(var(--ax-color-danger-500))}.ax-dark ax-form.ax-form-normal .ax-error-message:before{border-bottom-color:rgba(var(--ax-color-danger-500))}.ax-dark ax-form form.ax-float-error .ax-error-message{border-color:rgba(var(--ax-color-danger-700));background-color:rgba(var(--ax-color-danger-700));color:rgba(var(--ax-color-danger-fore))}.ax-dark ax-form form.ax-float-error .ax-error-message:before,.ax-dark ax-form form.ax-float-error .ax-error-message:after{border-bottom-color:rgba(var(--ax-color-danger-700))}.ax-dark ax-form form.ax-float-error .ax-error-message:before{border-bottom-color:rgba(var(--ax-color-danger-700))}ax-form-field{position:relative;display:block;width:100%}ax-form-field.ax-state-floating-label{--ax-size-default: 3.5rem}ax-form-field.ax-state-floating-label>ax-label{position:absolute;top:50%;transform:translateY(-50%);inset-inline-start:1rem;pointer-events:none;z-index:10;transition:all .15s ease-in-out;display:inline-grid}ax-form-field.ax-state-floating-label>ax-label label{margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}ax-form-field.ax-state-floating-label .ax-input::placeholder{opacity:0}ax-form-field.ax-state-floating-label.ax-state-focused>ax-label,ax-form-field.ax-state-floating-label.ax-state-has-value>ax-label{top:10%;transform:translateY(-10%);inset-inline-start:.25rem;padding:0 .5rem}ax-form-field.ax-state-floating-label.ax-state-focused>ax-label label,ax-form-field.ax-state-floating-label.ax-state-has-value>ax-label label{font-size:.75rem;color:rgba(var(--ax-color-text-default),.5)}ax-form-field.ax-state-floating-label.ax-state-focused .ax-input,ax-form-field.ax-state-floating-label.ax-state-focused .ax-content,ax-form-field.ax-state-floating-label.ax-state-focused ax-text-area,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-input,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-content,ax-form-field.ax-state-floating-label.ax-state-has-value ax-text-area{padding-top:.875rem}ax-form-field.ax-state-floating-label.ax-state-focused .ax-input::placeholder,ax-form-field.ax-state-floating-label.ax-state-focused .ax-content::placeholder,ax-form-field.ax-state-floating-label.ax-state-focused ax-text-area::placeholder,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-input::placeholder,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-content::placeholder,ax-form-field.ax-state-floating-label.ax-state-has-value ax-text-area::placeholder{opacity:1}ax-form-field.ax-state-floating-label.ax-state-focused ax-text-area textarea,ax-form-field.ax-state-floating-label.ax-state-has-value ax-text-area textarea{padding-top:1.5rem!important}ax-form-field.ax-state-over-label{--ax-size-default: 3.5rem}ax-form-field.ax-state-over-label>ax-label{position:absolute;pointer-events:none;z-index:10;transition:all .15s ease-in-out;display:inline-grid;top:10%;transform:translateY(-10%);inset-inline-start:.25rem;padding:0 .5rem}ax-form-field.ax-state-over-label>ax-label label{margin:0;overflow:hidden;text-overflow:ellipsis;font-size:.75rem;white-space:nowrap}ax-form-field.ax-state-over-label .ax-input::placeholder{opacity:0}ax-form-field.ax-state-over-label.ax-state-focused .ax-input,ax-form-field.ax-state-over-label.ax-state-focused .ax-content,ax-form-field.ax-state-over-label.ax-state-focused ax-text-area,ax-form-field.ax-state-over-label.ax-state-has-value .ax-input,ax-form-field.ax-state-over-label.ax-state-has-value .ax-content,ax-form-field.ax-state-over-label.ax-state-has-value ax-text-area{padding-top:1rem}ax-form-field.ax-state-over-label.ax-state-focused .ax-input::placeholder,ax-form-field.ax-state-over-label.ax-state-focused .ax-content::placeholder,ax-form-field.ax-state-over-label.ax-state-focused ax-text-area::placeholder,ax-form-field.ax-state-over-label.ax-state-has-value .ax-input::placeholder,ax-form-field.ax-state-over-label.ax-state-has-value .ax-content::placeholder,ax-form-field.ax-state-over-label.ax-state-has-value ax-text-area::placeholder{opacity:1}ax-form-field.ax-state-over-label.ax-state-focused ax-text-area textarea,ax-form-field.ax-state-over-label.ax-state-has-value ax-text-area textarea{padding-top:1.5rem!important}ax-form-field.ax-state-floating-label .ax-select-box-selection.ax-multiple,ax-form-field.ax-state-over-label .ax-select-box-selection.ax-multiple{padding-top:1.5rem!important;padding-inline-start:.75rem}ax-form-field .ax-error-message{margin-top:.25rem;margin-bottom:.25rem;display:block;font-size:.75rem;line-height:1rem}ax-form{width:100%}ax-form form.ax-bottom-error .ax-error-message{color:rgba(var(--ax-color-danger-500))}ax-form form.ax-float-error .ax-error-message{position:absolute;bottom:-2.5rem;z-index:20;display:block;width:fit-content;border-radius:.375rem;border-width:1px;border-color:rgba(var(--ax-color-danger-500));background-color:rgba(var(--ax-color-danger-500));padding:.25rem .5rem;font-weight:400;color:rgba(var(--ax-color-danger-fore))}ax-form form.ax-float-error .ax-error-message:before,ax-form form.ax-float-error .ax-error-message:after{pointer-events:none;position:absolute;bottom:100%;inset-inline-start:.75rem;z-index:20;height:0px;width:0px;border-bottom-color:rgba(var(--ax-color-danger-500));border-inline-end-color:transparent;border-inline-start-color:transparent;border-top-color:transparent;content:\"\"}ax-form form.ax-float-error .ax-error-message:before{margin-inline-start:-1px;border-width:4px;border-bottom-color:rgba(var(--ax-color-danger-500))}ax-form form.ax-float-error .ax-error-message:after{border-width:4px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ax-form-field', template: `<ng-content></ng-content>`, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, providers: [AXUnsubscriber], styles: [".ax-dark ax-form.ax-form-normal .ax-error-message{border-color:rgba(var(--ax-color-danger-500));background-color:rgba(var(--ax-color-danger-200));color:rgba(var(--ax-color-danger-fore-tint))}.ax-dark ax-form.ax-form-normal .ax-error-message:before,.ax-dark ax-form.ax-form-normal .ax-error-message:after{border-bottom-color:rgba(var(--ax-color-danger-500))}.ax-dark ax-form.ax-form-normal .ax-error-message:before{border-bottom-color:rgba(var(--ax-color-danger-500))}.ax-dark ax-form form.ax-float-error .ax-error-message{border-color:rgba(var(--ax-color-danger-700));background-color:rgba(var(--ax-color-danger-700));color:rgba(var(--ax-color-danger-fore))}.ax-dark ax-form form.ax-float-error .ax-error-message:before,.ax-dark ax-form form.ax-float-error .ax-error-message:after{border-bottom-color:rgba(var(--ax-color-danger-700))}.ax-dark ax-form form.ax-float-error .ax-error-message:before{border-bottom-color:rgba(var(--ax-color-danger-700))}ax-form-field{position:relative;display:block;width:100%}ax-form-field.ax-state-floating-label{--ax-size-default: 3.5rem}ax-form-field.ax-state-floating-label>ax-label{position:absolute;top:50%;transform:translateY(-50%);inset-inline-start:1rem;pointer-events:none;z-index:10;transition:all .15s ease-in-out;display:inline-grid}ax-form-field.ax-state-floating-label>ax-label label{margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}ax-form-field.ax-state-floating-label .ax-input::placeholder{opacity:0}ax-form-field.ax-state-floating-label.ax-state-focused>ax-label,ax-form-field.ax-state-floating-label.ax-state-has-value>ax-label{top:10%;transform:translateY(-10%);inset-inline-start:.25rem;padding:0 .5rem}ax-form-field.ax-state-floating-label.ax-state-focused>ax-label label,ax-form-field.ax-state-floating-label.ax-state-has-value>ax-label label{font-size:.75rem;color:rgba(var(--ax-color-text-default),.5)}ax-form-field.ax-state-floating-label.ax-state-focused .ax-input,ax-form-field.ax-state-floating-label.ax-state-focused .ax-content,ax-form-field.ax-state-floating-label.ax-state-focused ax-text-area,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-input,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-content,ax-form-field.ax-state-floating-label.ax-state-has-value ax-text-area{padding-top:.875rem}ax-form-field.ax-state-floating-label.ax-state-focused .ax-input::placeholder,ax-form-field.ax-state-floating-label.ax-state-focused .ax-content::placeholder,ax-form-field.ax-state-floating-label.ax-state-focused ax-text-area::placeholder,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-input::placeholder,ax-form-field.ax-state-floating-label.ax-state-has-value .ax-content::placeholder,ax-form-field.ax-state-floating-label.ax-state-has-value ax-text-area::placeholder{opacity:1}ax-form-field.ax-state-floating-label.ax-state-focused ax-text-area textarea,ax-form-field.ax-state-floating-label.ax-state-has-value ax-text-area textarea{padding-top:1.5rem!important}ax-form-field.ax-state-over-label{--ax-size-default: 3.5rem}ax-form-field.ax-state-over-label>ax-label{position:absolute;pointer-events:none;z-index:10;transition:all .15s ease-in-out;display:inline-grid;top:10%;transform:translateY(-10%);inset-inline-start:.25rem;padding:0 .5rem}ax-form-field.ax-state-over-label>ax-label label{margin:0;overflow:hidden;text-overflow:ellipsis;font-size:.75rem;white-space:nowrap}ax-form-field.ax-state-over-label .ax-input::placeholder{opacity:0}ax-form-field.ax-state-over-label.ax-state-focused .ax-input,ax-form-field.ax-state-over-label.ax-state-focused .ax-content,ax-form-field.ax-state-over-label.ax-state-focused ax-text-area,ax-form-field.ax-state-over-label.ax-state-has-value .ax-input,ax-form-field.ax-state-over-label.ax-state-has-value .ax-content,ax-form-field.ax-state-over-label.ax-state-has-value ax-text-area{padding-top:1rem}ax-form-field.ax-state-over-label.ax-state-focused .ax-input::placeholder,ax-form-field.ax-state-over-label.ax-state-focused .ax-content::placeholder,ax-form-field.ax-state-over-label.ax-state-focused ax-text-area::placeholder,ax-form-field.ax-state-over-label.ax-state-has-value .ax-input::placeholder,ax-form-field.ax-state-over-label.ax-state-has-value .ax-content::placeholder,ax-form-field.ax-state-over-label.ax-state-has-value ax-text-area::placeholder{opacity:1}ax-form-field.ax-state-over-label.ax-state-focused ax-text-area textarea,ax-form-field.ax-state-over-label.ax-state-has-value ax-text-area textarea{padding-top:1.5rem!important}ax-form-field.ax-state-floating-label .ax-select-box-selection.ax-multiple,ax-form-field.ax-state-over-label .ax-select-box-selection.ax-multiple{padding-top:1.5rem!important;padding-inline-start:.75rem}ax-form-field .ax-error-message{margin-top:.25rem;margin-bottom:.25rem;display:block;font-size:.75rem;line-height:1rem}ax-form{width:100%}ax-form form.ax-bottom-error .ax-error-message{color:rgba(var(--ax-color-danger-500))}ax-form form.ax-float-error .ax-error-message{position:absolute;bottom:-2.5rem;z-index:20;display:block;width:fit-content;border-radius:.375rem;border-width:1px;border-color:rgba(var(--ax-color-danger-500));background-color:rgba(var(--ax-color-danger-500));padding:.25rem .5rem;font-weight:400;color:rgba(var(--ax-color-danger-fore))}ax-form form.ax-float-error .ax-error-message:before,ax-form form.ax-float-error .ax-error-message:after{pointer-events:none;position:absolute;bottom:100%;inset-inline-start:.75rem;z-index:20;height:0px;width:0px;border-bottom-color:rgba(var(--ax-color-danger-500));border-inline-end-color:transparent;border-inline-start-color:transparent;border-top-color:transparent;content:\"\"}ax-form form.ax-float-error .ax-error-message:before{margin-inline-start:-1px;border-width:4px;border-bottom-color:rgba(var(--ax-color-danger-500))}ax-form form.ax-float-error .ax-error-message:after{border-width:4px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { input: [{
                type: ContentChild,
                args: [AXValuableComponent]
            }], label: [{
                type: ContentChild,
                args: [AXLabelComponent]
            }], __hostClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

const AX_FORM_CONFIG = new InjectionToken('AX_FORM_CONFIG', {
    providedIn: 'root',
    factory: () => {
        return AXFormDefaultConfig;
    },
});
const AXFormDefaultConfig = {};
function formConfig(config = {}) {
    const result = {
        ...AXFormDefaultConfig,
        ...config,
    };
    return result;
}

class AXValidationRuleDirective {
    constructor(host) {
        this.host = host;
    }
    ngOnInit() {
        this.host.addValidationRule({ rule: this.rule, options: this.ruleOptions });
    }
    ngOnDestroy() {
        this.host.removeValidationRule({
            rule: this.rule,
            options: this.ruleOptions,
        });
    }
    get ruleOptions() {
        return Object.assign({ message: this.message, name: this.host.name }, this.options);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXValidationRuleDirective, deps: [{ token: i1.AXValuableComponent }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.0.2", type: AXValidationRuleDirective, selector: "ax-validation-rule", inputs: { rule: "rule", options: "options", message: "message" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXValidationRuleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ax-validation-rule',
                }]
        }], ctorParameters: () => [{ type: i1.AXValuableComponent }], propDecorators: { rule: [{
                type: Input
            }], options: [{
                type: Input
            }], message: [{
                type: Input
            }] } });

class AXValidationSummaryComponent extends MXBaseComponent {
    get title() {
        return this._title;
    }
    set title(v) {
        this._title = v;
    }
    constructor(_tosatService, host) {
        super();
        this._tosatService = _tosatService;
        this.host = host;
        this._content = null;
        this._title = 'validation.messages.title';
        this.displayMode = 'toast';
        this.autoHide = false;
        //
        this.sub = host.onValidate.subscribe((e) => {
            if (e.result.result) {
                this._content = null;
            }
            else {
                const failedRules = e.result.rules.filter((c) => !c.result && c.message);
                this._content = `<ul>${failedRules.map((c) => this.formatRule({ title: c['title'], message: c.message })).join('')}</ul>`;
                this._timeOut = this.autoHide ? this.timeOut ?? Math.max(failedRules.length * 1000, 2000) : 0;
                if (this.displayMode == 'toast') {
                    this._tosatService.show({
                        color: 'danger',
                        closeButton: true,
                        timeOut: this._timeOut,
                        timeOutProgress: true,
                        content: this._content,
                        title: translateSync(this.title),
                        location: 'bottom-center',
                    });
                }
            }
            this.cdr.markForCheck();
        });
    }
    formatRule(rule) {
        return rule.title ? `<li><b>${rule.title}:</b> ${rule.message}</li>` : `<li>${rule.message}</li>`;
    }
    _handleOnDismissed() {
        this._content = null;
    }
    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXValidationSummaryComponent, deps: [{ token: i1$1.AXToastService }, { token: AXFormComponent, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.0.2", type: AXValidationSummaryComponent, selector: "ax-validation-summary", inputs: { title: "title", displayMode: "displayMode", timeOut: "timeOut", autoHide: "autoHide" }, usesInheritance: true, ngImport: i0, template: `
    @if (displayMode === 'alert' && _content) {
      <ax-alert color="danger" [timeOut]="_timeOut" #a (onClosed)="_handleOnDismissed()">
        <ax-icon></ax-icon>
        <ax-title>{{ title | translate | async }}</ax-title>
        <ax-content>
          <div [innerHTML]="_content"></div>
        </ax-content>
        <ax-footer>
          <ax-suffix>
            <ax-button text="Dismiss" (onClick)="a.close()"></ax-button>
          </ax-suffix>
        </ax-footer>
      </ax-alert>
    }
  `, isInline: true, dependencies: [{ kind: "component", type: i2.AXDecoratorIconComponent, selector: "ax-icon", inputs: ["icon"] }, { kind: "component", type: i2.AXDecoratorGenericComponent, selector: "ax-footer, ax-header, ax-content, ax-divider, ax-form-hint, ax-prefix, ax-suffix, ax-text, ax-title, ax-sub-title, ax-placeholder, ax-overlay" }, { kind: "component", type: i3.AXAlertComponent, selector: "ax-alert", inputs: ["color", "timeOut"], outputs: ["colorChange", "onClosed", "timeOutChange"] }, { kind: "component", type: i4.AXButtonComponent, selector: "ax-button", inputs: ["disabled", "size", "tabIndex", "color", "look", "text", "toggleable", "selected", "type", "loadingText"], outputs: ["onBlur", "onFocus", "onClick", "selectedChange", "toggleableChange", "lookChange", "colorChange", "disabledChange", "loadingTextChange"] }, { kind: "pipe", type: i5.AsyncPipe, name: "async" }, { kind: "pipe", type: i6.AXTranslatorPipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXValidationSummaryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ax-validation-summary',
                    template: `
    @if (displayMode === 'alert' && _content) {
      <ax-alert color="danger" [timeOut]="_timeOut" #a (onClosed)="_handleOnDismissed()">
        <ax-icon></ax-icon>
        <ax-title>{{ title | translate | async }}</ax-title>
        <ax-content>
          <div [innerHTML]="_content"></div>
        </ax-content>
        <ax-footer>
          <ax-suffix>
            <ax-button text="Dismiss" (onClick)="a.close()"></ax-button>
          </ax-suffix>
        </ax-footer>
      </ax-alert>
    }
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [{ type: i1$1.AXToastService }, { type: AXFormComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AXFormComponent]
                }] }], propDecorators: { title: [{
                type: Input
            }], displayMode: [{
                type: Input
            }], timeOut: [{
                type: Input
            }], autoHide: [{
                type: Input
            }] } });

class AXFormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.2", ngImport: i0, type: AXFormModule, declarations: [AXFormFieldComponent, AXFormComponent, AXValidationRuleDirective, AXValidationSummaryComponent], imports: [CommonModule, AXDecoratorModule, AXAlertModule, AXButtonModule, AXValidationModule, AXTranslationModule], exports: [AXFormFieldComponent, AXFormComponent, AXValidationRuleDirective, AXValidationSummaryComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormModule, imports: [CommonModule, AXDecoratorModule, AXAlertModule, AXButtonModule, AXValidationModule, AXTranslationModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AXFormFieldComponent, AXFormComponent, AXValidationRuleDirective, AXValidationSummaryComponent],
                    imports: [CommonModule, AXDecoratorModule, AXAlertModule, AXButtonModule, AXValidationModule, AXTranslationModule],
                    exports: [AXFormFieldComponent, AXFormComponent, AXValidationRuleDirective, AXValidationSummaryComponent],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AXFormComponent, AXFormDefaultConfig, AXFormFieldComponent, AXFormModule, AXFormValidationEvent, AXValidationRuleDirective, AXValidationSummaryComponent, AX_FORM_CONFIG, formConfig };
